import React from 'react';
import '../../../styles/Table.css';

interface HasId {
  id: number;
}

interface ReadOnlyTableBodyProps<T extends HasId> {
  items: T[];
  renderItem: (item: T) => React.JSX.Element;
}

const ReadOnlyTableBody = <T extends HasId>({
  items,
  renderItem,
}: ReadOnlyTableBodyProps<T>) => {
  return (
    <tbody>
      {items?.length > 0 &&
        items.map((item) => <tr key={item.id}>{renderItem(item)}</tr>)}
    </tbody>
  );
};

export default ReadOnlyTableBody;
